export const PROFILE_URL = 'https://blobtalentai.blob.core.windows.net/storagezepcruit/profile-pictures/zepcruit-user-profile-placeholder.webp';